import { render, staticRenderFns } from "./AdminTopHeader.vue?vue&type=template&id=534e4f08&scoped=true&"
import script from "./AdminTopHeader.vue?vue&type=script&lang=ts&"
export * from "./AdminTopHeader.vue?vue&type=script&lang=ts&"
import style0 from "./AdminTopHeader.vue?vue&type=style&index=0&id=534e4f08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534e4f08",
  null
  
)

export default component.exports
import QHeader from 'quasar/src/components/header/QHeader.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QHeader,QToolbar,QBtn,QIcon});
